import { forEach } from 'lodash';
import gadl from 'components/Analytics/GoogleAnalytics/DataLayer';

/**
 * references
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
 */

const events = {
  'product-added-to-cart': [gadl.addToCart],

  'product-removed-from-cart': [gadl.removeFromCart],

  'products-impression': [gadl.productsListView],

  'product-view': [gadl.productView],

  'product-click': [gadl.productClick],

  'view-cart': [gadl.viewCart],

  'begin-checkout': [gadl.beginCheckout],

  'add-payment-info': [gadl.addPaymentInfo],

  'add-shipping-info': [gadl.addShippingInfo],

  'purchase-success': [gadl.purchase],

  'product-search': [gadl.productSearch]
};

forEach(events, (listeners, event) => {
  forEach(listeners, listener => {
    VueEventHub.$on(event, listener);
  });
});
